import React, { useState , useEffect, useRef } from "react";
import Header from "../elements/header/Header";
import Footer from "../elements/footer/Footer";
import { Outlet, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import Lenis from "lenis";
import ReactLenis, { useLenis } from "lenis/react";

export default function Root(){

    const [searchParams, setSearchParams] = useSearchParams();

    const lenisRef = useRef(null);

    useEffect(() => {
        const lenis = lenisRef.current?.lenis;
        if (!lenis) return;
        if (searchParams.get("view") === "true") {
            lenis.stop();
        } else {
            lenis.start();
        }
    },[searchParams])

    return (
        <>
            <ReactLenis root ref={lenisRef}/>
            <Header />
            <Outlet />
            <Footer />
        </>
    );
}
